import React from "react";
import { StandardChoiceCheckboxCriterion } from "../search/criteria/components/checkboxes/StandardChoiceCheckboxCriterion";
import { RadioButtonTabsCriterion } from "../search/criteria/components/radio/RadioButtonTabsCriterion";
import { SearchGroup } from "../search/criteria/searchGroup";
import { VisibilitySelector } from "../common/VisibilitySelector";
import { getChoicesEndpoint } from "../search/utils";
import { winnersAndLosersSearchBy } from "./searchOptions";

export const searchComponents = [
	new SearchGroup("Winners and Losers", "winnersAndLosers")
		.add("winners_continent", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Continent"
				endpoint={getChoicesEndpoint("continent")}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "winners")
				}
				quickSearch={true}
			/>
		))
		.add("winners_country", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Country"
				endpoint={getChoicesEndpoint("country")}
				parentKeys={["continent"]}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "winners")
				}
				quickSearch={true}
			/>
		))
		.add("winners_type", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Operator Type"
				endpoint={getChoicesEndpoint("airline_type")}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "winners")
				}
				quickSearch={true}
			/>
		))
		.add("losers_continent", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Continent"
				endpoint={getChoicesEndpoint("continent")}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "losers")
				}
				quickSearch={true}
			/>
		))
		.add("losers_country", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Country"
				endpoint={getChoicesEndpoint("country")}
				parentKeys={["continent"]}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "losers")
				}
				quickSearch={true}
			/>
		))
		.add("losers_type", (key) => (
			<StandardChoiceCheckboxCriterion
				criterionKey={key}
				label="Operator Type"
				endpoint={getChoicesEndpoint("airline_type")}
				visibilitySelector={
					new VisibilitySelector("airline_search_by", "losers")
				}
				quickSearch={true}
			/>
		)),
];

export const tabComponent = (
	<RadioButtonTabsCriterion
		criterionKey="airline_search_by"
		label="Search by"
		choices={winnersAndLosersSearchBy}
	/>
);
